/**
 * orga-app-api - einlasskontrolle-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CoronaCertValidationResult { 
    mandant_id: string;
    check_date_utc?: Date;
    ist_nicht_ok?: boolean;
    ist_ok?: boolean;
    ist_fehler?: boolean;
    fehler_code?: number;
    fehler_text?: string;
    ist_stichprobe?: boolean;
    ist_2g_plus_ok?: boolean;
    nicht_ok_code?: number;
    nicht_ok_text?: string;
    check_vorname?: string;
    check_nachname?: string;
    check_geburtstag?: string;
    t?: string;
    standard_name?: string;
}

